import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { HeartPulse, Baby, Bandage, Building2, GraduationCap, Sparkles, Users, ArrowRight } from "lucide-react";

const services = [
  { icon: HeartPulse, title: "Adult CPR & AED", body: "Certification-track training in adult CPR, AED operation, and choking response.", color: "text-brand-coral" },
  { icon: Baby, title: "Pediatric CPR & AED", body: "Infant and child CPR designed for parents, caregivers, and childcare professionals.", color: "text-brand-teal" },
  { icon: Bandage, title: "First Aid", body: "Response to common injuries, bleeding control, and everyday emergencies.", color: "text-brand-amber" },
  { icon: Sparkles, title: "CPR, AED & First Aid Combo", body: "Comprehensive combination courses for teams needing full certification.", color: "text-brand-coral" },
  { icon: Users, title: "Childcare-Focused Training", body: "PA state-compliant courses tailored for daycare and childcare teams.", color: "text-brand-teal" },
  { icon: Building2, title: "Workplace Safety", body: "OSHA-aligned safety instruction for businesses and industrial teams.", color: "text-brand-navy" },
];

export default function Services() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
      <div className="max-w-3xl">
        <span className="font-script text-3xl text-brand-coral">What we offer</span>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold text-brand-navy tracking-tight mt-2">Training Services</h1>
        <p className="mt-4 text-lg text-slate-600 leading-relaxed">
          Every course is hands-on, evidence-based, and taught with the warmth of an instructor who wants you to leave truly capable.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {services.map((s) => (
          <div key={s.title} className="bg-white border border-slate-200 rounded-2xl p-8 hover:border-brand-teal hover:shadow-md transition-all" data-testid={`service-${s.title}`}>
            <s.icon className={`h-10 w-10 ${s.color}`} />
            <h3 className="font-display font-bold text-xl text-brand-navy mt-4">{s.title}</h3>
            <p className="mt-2 text-slate-600 leading-relaxed">{s.body}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 bg-brand-navy text-white rounded-3xl p-10 md:p-14 relative overflow-hidden">
        <GraduationCap className="absolute -right-8 -top-8 h-48 w-48 text-white/5" />
        <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight max-w-2xl">Not sure which course fits your team?</h2>
        <p className="mt-3 text-white/80 max-w-2xl">Tell us who you're training and we'll recommend the right class or build a custom program.</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/group-training"><Button className="bg-brand-coral hover:bg-brand-coral-dark rounded-full px-8 py-6 font-bold btn-lift" data-testid="services-cta-inquiry">Get a recommendation <ArrowRight className="ml-2 h-4 w-4" /></Button></Link>
          <Link to="/classes"><Button variant="outline" className="border-brand-teal text-white bg-transparent hover:bg-brand-teal rounded-full px-8 py-6 font-bold btn-lift" data-testid="services-cta-classes">Browse open classes</Button></Link>
        </div>
      </div>
    </div>
  );
}
